import { toString, trim } from 'lodash/fp';

const formatPhoneNumber = (value, delimiter = '-') => (value
  ? trim(`${toString(value).slice(0, 3)}${delimiter}${toString(value).slice(3, 7)}${delimiter}${toString(value).slice(7)}`)
  : '-'
);

export default formatPhoneNumber;
